import { useState } from "react";
import {
  PieChart,
  PieInnerText,
  StackedGroupBarChart,
  Tabs,
} from "@jana-technology/platform-ui";

import { xAccessor } from "helpers/charts";
import { SM_BAR_CHART_SIZE, XS_BAR_CHART_SIZE } from "constants/charts";
import { useGlobalFiltersContext } from "contexts/filters/global-filters";
import { usePublishedRiskUnitFormatter } from "hooks/usePublishedRiskUnitFormatter";
import { useTopRiskWellsByThreatOperational } from "hooks/queries";

import ChartCard from "./ChartCard";
import { returnTopRiskWellsChartTitle } from "hooks/utils";

// TODO: lazy load this chart since it's at the bottom
export const TopRiskWellsByThreatOperational = () => {
  const { hierarchyIdsOverview } = useGlobalFiltersContext();
  const riskUnitFormatter = usePublishedRiskUnitFormatter();

  const topRiskResult = useTopRiskWellsByThreatOperational({
    variables: { hierarchyIds: hierarchyIdsOverview },
  });

  const [activeTab, setActiveTab] = useState<
    "riskByThreatsData" | "riskByConsequenceData" | "riskByOutcomeData"
  >("riskByThreatsData");

  const chartSize =
    window.innerWidth <= 1600 ? XS_BAR_CHART_SIZE : SM_BAR_CHART_SIZE;

  return (
    <ChartCard
      loading={topRiskResult.loading}
      loaderClassName="h-[700px] w-full"
      heading={
        <span className="flex justify-between">
          <span className="mr-6">
            {returnTopRiskWellsChartTitle(activeTab)}
          </span>
          <Tabs
            kind="secondary"
            onValueChange={setActiveTab as (value: string) => void}
            items={[
              { label: "Threat", id: "riskByThreatsData" },
              { label: "Consequence", id: "riskByConsequenceData" },
              { label: "Outcome Scenario", id: "riskByOutcomeData" },
            ]}
          />
        </span>
      }
    >
      <div className="flex justify-between">
        <StackedGroupBarChart
          withScroll
          withBarLabels
          barWidth={32}
          yDomainPadding={1.05}
          height={chartSize.height}
          data={topRiskResult[activeTab]}
          dataKeys={topRiskResult[`${activeTab}Keys`]}
          referenceLines={topRiskResult.topWellsMedianLines}
          xAccessor={xAccessor}
          chartName={returnTopRiskWellsChartTitle(activeTab)}
          yAxisLabel="Operational Risk"
          xAxisLabel="Wells"
          yTickFormatter={riskUnitFormatter}
        />
        <div className="flex items-center">
          <PieChart
            className="ml-6"
            title="System Risk Breakdown"
            pies={topRiskResult.topWellsPieChartData}
          >
            {topRiskResult.topWellsPieChartInnerText.map((pieInnerText) => (
              <PieInnerText
                key={pieInnerText.label}
                label={pieInnerText.label}
                value={pieInnerText.value}
              />
            ))}
          </PieChart>
        </div>
      </div>
    </ChartCard>
  );
};

export default TopRiskWellsByThreatOperational;
